/* ============================================================================
   OTF — sheets open in the customer's language.  2026-09-02 (Bu Site)
   CEO: "fix the arabic and make sure terms and anything legal should be in
   arabic without dialect."

   THE BUG
   -------
   fluid-motion.js turns any /pages/ or /policies/ link into the rising sheet.
   Its matcher is prefix-based:

       path.indexOf("/pages/") !== 0 && path.indexOf("/policies/") !== 0
         || (e.preventDefault(), open(path, ...))

   and open() -> load(el, path) -> fetch(path).

   So on /ar it matches the UNPREFIXED "/pages/gifts" and fetches exactly that,
   which Shopify serves in ENGLISH.  A correctly localised "/ar/pages/gifts"
   fails the matcher entirely and navigates away instead of opening a sheet.
   Net effect: EVERY sheet on /ar — Gifts, Care guide, Events, Business — opened
   in English.  It reached a legal surface: the cash-gift tick-box was shown to
   Arabic shoppers in English and recorded "Terms locale: en" against them.

   WHY THIS IS A SEPARATE FILE AND NOT AN EDIT TO fluid-motion.js
   -------------------------------------------------------------
   Re-measured 2026-09-15 on the Skeleton build: the theme file is 170,828
   bytes (md5 7b7cb15a…) while the CDN serves 106,313 bytes (md5 420c1d92…).
   The served copy is NOT the stored copy, so a byte-perfect local copy cannot
   be obtained by downloading it — which makes the checksum-before-editing
   procedure impossible on that file, and hand-retyping 170 KB of minified JS
   into a shared theme is the single most likely way to destroy it.  The theme
   now sets this precedent five times over: fluid-rv-sheet.js, fluid-sub.js,
   otf-slot-cutoff.js, otf-address-skip.js and this file all attach from the
   OUTSIDE rather than editing fluid-motion.js.
   If that file is ever rebuilt from source, fold this in and delete this file.
   (On 2026-09-02 the same two figures were 170,418 / ed8bda03… and
   106,139 / 2edb24f4….  They moved with the 6 Sep rebuild, which is why they
   carry a date here: an undated byte count in a comment goes stale in silence.)

   WHAT IT DOES
   ------------
   a) Normalises already-localised links ("/ar/pages/x") back to the shape the
      matcher expects, in the CAPTURE phase so it runs before fluid-motion's
      own bubble-phase handler.  Without this, a correctly written Arabic link
      would navigate instead of opening a sheet.
   b) Re-adds the locale root to same-origin /pages/ and /policies/ fetches, so
      the sheet fetches the Arabic page.  The locale root comes from Shopify's
      own Shopify.routes.root ("/ar/" on Arabic, "/" on English) — never guessed
      and never hardcoded.

   Inert on the primary locale: PREFIX is empty there and the file returns
   before touching anything.  Scope is deliberately narrow — same-origin,
   root-relative, /pages/ or /policies/ only.
   ========================================================================= */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PREFIX = String(ROOT).replace(/\/+$/, '');   /* '' on English, '/ar' on Arabic */
  if (!PREFIX) { return; }

  var SHEET = /^\/(pages|policies)\//;
  var pathOf = function (u) { return String(u).split('#')[0].split('?')[0]; };

  /* (a) "/ar/pages/x" -> "/pages/x" so fluid-motion's matcher recognises it.
         Capture phase: this must run before its document-level click handler. */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) { return; }
    var a = (e.target && e.target.closest) ? e.target.closest('a[href]') : null;
    if (!a || a.target === '_blank') { return; }
    var href = a.getAttribute('href');
    if (!href || href.indexOf(PREFIX + '/') !== 0) { return; }
    var rest = href.slice(PREFIX.length);
    if (!SHEET.test(pathOf(rest))) { return; }
    a.setAttribute('href', rest);
  }, true);

  /* (b) the fix: give the sheet's own fetch the localised path. */
  if (window.__otfSheetLocale || typeof window.fetch !== 'function') { return; }
  window.__otfSheetLocale = PREFIX;

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var next = input;
    try {
      var url = (typeof input === 'string') ? input
        : (input && typeof input.url === 'string') ? input.url : null;
      if (url && url.charAt(0) === '/' && SHEET.test(pathOf(url))) {
        next = (typeof input === 'string')
          ? PREFIX + url
          : new Request(PREFIX + url, input);
      }
    } catch (err) {
      next = input;   /* never let this break a fetch */
    }
    return nativeFetch.call(this, next, init);
  };
})();